import NotLoggedIn from './notLoggedIn'

export default NotLoggedIn
